<template>
  <div class="connect-motion-bank-landing">
    <router-link to="/dashboard">
      <div class="back-button-connect">
        <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.14888 0.831011L1.07322 5.90668C0.308927 6.67097 0.308927 7.90559 1.07322 8.66988L6.14888 13.7455C7.38351 14.9802 9.5 14.0983 9.5 12.3541L9.5 2.20281C9.5 0.458665 7.38351 -0.40361 6.14888 0.831011Z" fill="#C62127"/>
        </svg>
        Kembali ke Dashboard Partai Perindo
      </div>
    </router-link>
    <div class="connect-motion-bank-content">
      <form @submit.prevent="preSaveBankAccount">
        <span class="text-bold text-2xl mb-1" v-if="!isEdit">Data Nasabah MotionBanking</span>
        <span class="text-bold text-2xl mb-1" v-if="isEdit">Edit data Nasabah MotionBanking</span>
        <div class="form-input">
          <label for="name" class="text-blue-accent text-bold">Nomor Rekening</label>
          <small>Nomor rekening MotionBanking anda</small>
          <InpuText v-model="form.account" required @keypress="isNumberOnly" :showError="false" minlength="15" placeholder="Masukan 15 digit no rekening anda" />
        </div>
        <div class="form-input">
          <label for="name" class="text-blue-accent text-bold">NIK</label>
          <small>Masukan NIK sesuai dengan yang terdaftar</small>
          <InpuText :showError="false" disabled v-model="form.nik" placeholder="Masukan NIK anda yang terdaftar" />
        </div>
        <div class="form-input">
          <label for="name" class="text-blue-accent text-bold">Nomor HP</label>
          <small>Masukan Nomor HP yang terdaftar</small>
          <InpuText :showError="false" disabled v-model="form.phoneNumber" placeholder="Masukan nomor HP anda yang terdaftar" />
        </div>

        <button type="submit" class="button-primary text-bold p-1rem mt-2">SIMPAN</button>
      </form>
    </div>
  </div>
</template>

<script setup>
import InpuText from '../../../components/Form/InpuText.vue'
import { onMounted, ref } from 'vue'
import axios from 'axios'
import { useAlert } from '../../../composable/useAlert'
import { useRoute, useRouter } from 'vue-router'

const alert = useAlert()
const router = useRouter()
const route = useRoute()

const form = ref({
  account: '',
  nik: '',
  phoneNumber: ''
})

const isEdit = ref(false)

onMounted(async () => {
  isEdit.value = await route.query?.action === 'edit' || false
  if (isEdit.value) {
    form.value.account = route.query?.q
  }

  getUserDataForBankAccount()
})

const isNumberOnly = (e) => {
  const char = String.fromCharCode(e.keyCode)
  if (/^\d+$/.test(char)) return true
  else e.preventDefault()
}

const getUserDataForBankAccount = async () => {
  try {
    const { data } = await axios.get('member/member/dataforbank')
    // console.log({ data })
    const { nik, phone_number: phoneNumber } = data

    form.value.nik = nik
    form.value.phoneNumber = phoneNumber
  } catch (error) {
  }
}

const preSaveBankAccount = () => {
  if (!isEdit.value) {
    return alert.alertConfirmation({ message: 'Apakah anda yakin data yang anda masukan sesuai dengan data di MotionBanking Anda ?', callback: saveBankAccount })
  }
  alert.alertConfirmation({ message: 'Apakah anda yakin data yang anda masukan sesuai dengan data di MotionBanking Anda ?', callback: editBankAccount })
}

const saveBankAccount = async () => {
  const { nik, phoneNumber, account } = form.value

  const params = new FormData()
  params.append('nik', nik)
  params.append('account_number', account)
  params.append('mobile_number', phoneNumber)

  try {
    const res = await axios.post('member/member/bank', params)
    alert.alertNormalWithCallback({
      message: res.data,
      callback: () => {
        alert.closeAlert()
        router.push('/dashboard')
      }
    })
  } catch (err) {
    alert.alertFailed({ message: err.response.data })
  }
}

const editBankAccount = async () => {
  const { nik, phoneNumber, account } = form.value

  const params = new FormData()
  params.append('nik', nik)
  params.append('account_number', account)
  params.append('mobile_number', phoneNumber)

  try {
    const res = await axios.patch('member/member/bank', params)
    alert.alertNormalWithCallback({
      message: res.data,
      callback: () => {
        alert.closeAlert()
        router.push('/dashboard')
      }
    })
  } catch (err) {
    alert.alertFailed({ message: err.response.data })
  }
}
</script>

<style lang="scss" scoped>
.connect-motion-bank-landing {
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 4rem;

  @media screen and (max-width: 600px) {
    gap: 1rem;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .form-input {
    display: flex;
    flex-direction: column;
    gap: .5rem;
  }

  .back-button-connect {
    display: flex;
    align-items: center;
    gap: .5rem;

    color: #ED1C24;
    font-weight: 500;
  }

}
</style>
